import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AgGridAngular } from 'ag-grid-angular';
import { forkJoin, lastValueFrom } from 'rxjs';
import { ConfirmationComponent } from '../confirmation/confirmation.component';
import { RouterConstants } from '../constants/router-constants';
import { LoaderService } from '../loader/loader.service';
import { CepmService } from '../services/cepm.service';
import { FeedbackNotificationService } from '../services/feedback-notification.service';
import { LookupService } from '../services/lookup.service';
import { SplunkLogsService } from '../services/splunkLogs.service';
import { FeedbackIdRendererComponent } from './feedback-id-renderer/feedback-id-renderer.component';
import { ReportRendererComponent } from './report-renderer/report-renderer.component';
import { FileUploadService } from '../services/file-upload.service';
import { DateFilterService } from '../services/date-filter.service';

@Component({
    selector: 'app-report-issues',
    templateUrl: './report-issues.component.html',
    styleUrls: ['./report-issues.component.css'],
    standalone: false
})
export class ReportIssuesComponent implements OnInit {
  @ViewChild('allIssueGrid') allIssueGrid: AgGridAngular;
  @ViewChild('feedbackHistoryGrid') feedbackHistoryGrid: AgGridAngular;
  incidentId: any;
  @Output() clickReportIssues = new EventEmitter<any>();
  @Input() initialTab: number;
  issueForm: UntypedFormGroup;
  feedbackForm: UntypedFormGroup;
  feedbackModuleArr: any = [];
  moduleSearchText = new FormControl();
  isAllModulesSelected = false;
  supportedFileExtensions: any = 'JPG, JPEG, PNG, PDF, XLS, XLSX, PPT, PPTX, DOC, DOCX,';
  categories: any = ['Report Wrong / Missing Data', 'Report Broken Link / Application / Access Issues'];
  showBrokenLink: any = false;
  showDataMeasureName: any = false;
  selectedFiles: any = [];
  reportTabs: any = ['Feedback', 'Report New Issue', 'My Issues', 'All Issues'];
  selectedReportTabIndex: any = -1;
  modalRefBox: any;
  showIncident = false;
  showFeedbackDetail = false;
  selectedFeedbackDetail: any;
  incidentComments: any = [];
  loggedInUser: any = '';
  dataMeasureArr: any = [];
  incidentIdArr: any = [];
  searchedText: any = '';
  feedbackImageFiles: File[] = [];
  feedbackImageValidationError: string = '';
  feedbackImageUploading: boolean = false;
  readonly maxFeedbackImages = 5;
  readonly maxFeedbackImagesTotalBytes = 25 * 1024 * 1024;
  readonly feedbackImageExtensions = 'JPG, JPEG, PNG';
  btnText: any;
  userType: any;
  feedbackHistoryTabIndex = -1;
  reportNewIssueTabIndex = 1;
  myIssuesTabIndex = 2;
  allIssuesTabIndex = 3;

  public frameworkComponents;
  public context;

  // My Issues
  myIssuesList: any = {
    rowData: [],
    columnDefs: [
      {
        headerName: 'Case Category',
        headerTooltip: 'Case Category',
        field: 'summary',
        tooltipValueGetter: (params) => params.value,
        flex: 1
      },
      {
        headerName: 'Description',
        headerTooltip: 'Description',
        field: 'description',
        tooltipValueGetter: (params) => params.value,
        width: 400,
        flex: 1
      },
      {
        headerName: 'Case Number',
        headerTooltip: 'Case Number',
        field: 'case_no',
        tooltipValueGetter: (params) => params.value,
        flex: 1,
        cellRenderer: 'reportRenderer'
      },
      {
        headerName: 'Created On',
        field: 'created_on',
        headerTooltip: 'Created On',
        tooltipValueGetter: (params) => params.value,
        type: 'dateColumn'
      },
      {
        headerName: 'Action',
        headerTooltip: 'Action',
        tooltipValueGetter: (params) => params.value,
        cellRenderer: 'reportRenderer',
        width: 150
      }
    ]
  };


  // issueList
  allIssueList: any = {
    rowData: [],
    columnDefs: [
      {
        headerName: 'Case Category',
        headerTooltip: 'Case Category',
        field: 'summary',
        tooltipValueGetter: (params) => params.value,
        flex: 1,
        width: 350
      },
      {
        headerName: 'Description',
        headerTooltip: 'Description',
        field: 'description',
        tooltipValueGetter: (params) => params.value,
        width: 400,
        flex: 1
      },
      {
        headerName: 'Case Number',
        headerTooltip: 'Case Number',
        field: 'case_no',
        tooltipValueGetter: (params) => params.value,
        flex: 1,
        cellRenderer: 'reportRenderer',
        width: 80
      },
      {
        headerName: 'Created On',
        field: 'created_on',
        headerTooltip: 'Created On',
        tooltipValueGetter: (params) => params.value,
        flex: 1,
        width: 150,
        type: 'dateColumn'
      },
      {
        headerName: 'Created By',
        field: 'created_by',
        headerTooltip: 'Created By',
        tooltipValueGetter: (params) => params.value,
        flex: 1,
        width: 100
      },
      {
        headerName: 'Supplier Name',
        field: 'supplier_name',
        headerTooltip: 'Supplier Name',
        tooltipValueGetter: (params) => params.value,
        flex: 1,
        width: 150
      },
      {
        headerName: 'Action',
        headerTooltip: 'Action',
        tooltipValueGetter: (params) => params.value,
        cellRenderer: 'reportRenderer',
        width: 150,
        filter: false
      }
    ]
  };

  feedbackHistoryList: any = {
    rowData: [],
    columnDefs: [
      {
        headerName: 'Feedback ID',
        headerTooltip: 'Feedback ID',
        field: 'feedbackId',
        tooltipValueGetter: (params) => params.value,
        cellRenderer: 'feedbackIdRenderer',
        width: 150,
        flex: 1
      },
      {
        headerName: 'Feedback',
        headerTooltip: 'Feedback',
        field: 'feedback',
        tooltipValueGetter: (params) => params.value,
        cellClass: 'feedback-cell-ellipsis',
        flex: 2,
        width: 400
      },
      {
        headerName: 'Module Name',
        headerTooltip: 'Module Name',
        field: 'moduleName',
        tooltipValueGetter: (params) => params.value,
        cellClass: 'feedback-cell-ellipsis',
        flex: 1,
        width: 180
      },
      {
        headerName: 'Company',
        headerTooltip: 'Company',
        field: 'supplierName',
        tooltipValueGetter: (params) => params.value,
        flex: 1
      },
      {
        headerName: 'Submitted by',
        headerTooltip: 'Submitted by',
        field: 'submittedBy',
        tooltipValueGetter: (params) => params.value,
        flex: 1
      },
      {
        headerName: 'Submitted date',
        headerTooltip: 'Submitted date',
        field: 'submittedDate',
        tooltipValueGetter: (params) => params.value,
        type: 'dateColumn',
        flex: 1
      }
    ]
  };

  constructor(
    private readonly modalService: NgbModal,
    private readonly loaderService: LoaderService,
    private readonly cepmService: CepmService,
    private readonly routerConstants: RouterConstants,
    public readonly dateFilter: DateFilterService,
    private readonly fb: UntypedFormBuilder,
    private readonly lookupService: LookupService,
    private readonly ref: ChangeDetectorRef,
    private readonly splunkLogService: SplunkLogsService,
    public  readonly fileUploadService: FileUploadService,
    private readonly feedbackNotificationService: FeedbackNotificationService
  ) {
    ref.detach();
    setInterval(() => {
      this.ref.detectChanges();
    }, 200);
    this.context = { componentParent: this };
    this.frameworkComponents = {
      reportRenderer: ReportRendererComponent,
      feedbackIdRenderer: FeedbackIdRendererComponent
    };
    this.fileUploadService.resetState();
  }

  ngOnInit(): void {
    (async () => {
      await this.initializeCepmRoleIfReload();
      this.loggedInUser = this.routerConstants.getLoggedInUser();
      this.issueForm = this.fb.group({
        category: ['', [Validators.required]],
        dataMeasureName: [''],
        brokenLinkName: [''],
        additionalComments: ['', [Validators.required]],
        fileName: ['']
      });
      this.feedbackForm = this.fb.group({
        scwModule: [[], [Validators.required, (c) => Array.isArray(c.value) && c.value.length ? null : { required: true }]],
        feedbackComment: ['', [Validators.required]]
      });
      this.userType = this.routerConstants.getUserType();
      this.configureTabsForUserType();
      this.updateTabIndices();
      this.getLookupValues();
    })();
  }

  private async initializeCepmRoleIfReload(): Promise<void> {
    if (window.localStorage.getItem('type') === 'reload') {
      await this.cepmService.getCepmRole(true);
    }
  }

  private configureTabsForUserType(): void {
    if (this.userType !== 'scw_admin' && this.userType !== 'scw_supplier_user') {
      this.reportTabs.splice(-1);
    }
    if (this.userType === 'scw_supplier_user') {
      this.renameActionColumnToViewUpdates(this.allIssueList.columnDefs);
      this.renameActionColumnToViewUpdates(this.myIssuesList.columnDefs);
    }
    if (this.userType === 'scw_admin') {
      this.reportTabs.splice(1, 0, 'Feedback History');
    }
  }

  private renameActionColumnToViewUpdates(columnDefs: any[]): void {
    for (const column of columnDefs) {
      if (column.headerName === 'Action') {
        column.headerName = 'View Updates';
        column.headerTooltip = 'View Updates';
      }
    }
  }

  async getLookupValues() {
    this.loaderService.openLoader();

    await lastValueFrom(forkJoin([
      this.lookupService.getDropdownLookup('SCW_DATA_MEASURE'),
      this.lookupService.getDropdownLookup('SCW_REPORT_ISSUES_BTN'),
      this.lookupService.getDropdownLookup('SCW_FEEDBACK_MODULE_TYPE')
    ]))
      .then((respData: any) => {
        this.loaderService.closeLoader();
        if (respData && respData.length > 0) {
          this.dataMeasureArr = respData[0].lookupArray;
          this.btnText = respData[1].lookupArray[0].description;
          this.feedbackModuleArr = respData[2].lookupArray;
        }
      })
      .catch((err: any) => {
        this.loaderService.closeLoader();
        this.openConfirmationPopup('Error', err?.error?.errorMsg || 'An error occurred', false);
      });
    const initialTabIndex = this.resolveInitialTabIndex();
    this.onChangeSelectedTab(initialTabIndex);
    if (initialTabIndex === 0) {
      this.refreshFeedbackModuleSelect();
    }
  }

  private updateTabIndices(): void {
    this.feedbackHistoryTabIndex = this.reportTabs.indexOf('Feedback History');
    this.reportNewIssueTabIndex = this.reportTabs.indexOf('Report New Issue');
    this.myIssuesTabIndex = this.reportTabs.indexOf('My Issues');
    this.allIssuesTabIndex = this.reportTabs.indexOf('All Issues');
  }

  private resolveInitialTabIndex(): number {
    if (this.initialTab === 0) {
      return 0;
    }
    // Semantic 2 from shell feedback launcher for scw_admin → Feedback History tab.
    if (this.initialTab === 2 && this.feedbackHistoryTabIndex >= 0) {
      return this.feedbackHistoryTabIndex;
    }
    if (this.initialTab === undefined || this.initialTab === 1) {
      return this.reportNewIssueTabIndex >= 0 ? this.reportNewIssueTabIndex : 0;
    }
    return Math.min(this.initialTab, this.reportTabs.length - 1);
  }

  private refreshFeedbackModuleSelect(): void {
    setTimeout(() => this.ref.detectChanges());
  }

  onChangeSelectedTab(selectedTabIndex: any) {
    this.selectedReportTabIndex = selectedTabIndex;
    this.showBrokenLink = false;
    this.showDataMeasureName = false;
    this.issueForm.reset();
    this.feedbackForm.reset({ scwModule: [], feedbackComment: '' });
    this.isAllModulesSelected = false;
    this.moduleSearchText.setValue('');
    this.incidentComments = [];
    this.searchedText = '';
    this.feedbackImageFiles = [];
    this.feedbackImageValidationError = '';
    this.feedbackImageUploading = false;
    if (selectedTabIndex === this.myIssuesTabIndex) {
      this.getMyIssues();
    } else if (selectedTabIndex === this.allIssuesTabIndex) {
      this.getAllIssues();
    } else if (selectedTabIndex === this.feedbackHistoryTabIndex) {
      this.getFeedbackHistory();
    }
    if (selectedTabIndex === 0) {
      this.refreshFeedbackModuleSelect();
    }
  }

  onSelectModule(event?: any) {
    if (event) {
      this.isAllModulesSelected = !!event.checked;
      if (event.checked) {
        const allModules = this.feedbackModuleArr.map((m: any) => m.description);
        this.feedbackForm.get('scwModule').setValue(allModules);
      }
      else {
        this.feedbackForm.get('scwModule').setValue([]);
      }
    }
    else {
      const selectedModules = (this.feedbackForm.get('scwModule').value || [])
        .filter((m: any) => m !== 'Select All');
      this.isAllModulesSelected = selectedModules.length === this.feedbackModuleArr.length;
      this.feedbackForm.get('scwModule').setValue(selectedModules);
    }
    this.feedbackForm.get('scwModule').markAsTouched();
  }

  private getSelectedModuleTypeIds(): string[] {
    const selectedDescriptions = (this.feedbackForm.get('scwModule').value || [])
      .filter((m: any) => m !== 'Select All');
    return this.feedbackModuleArr
      .filter((m: any) => selectedDescriptions.includes(m.description))
      .map((m: any) => String(m.id))
      .filter((id: string) => !!id);
  }

  private getFeedbackSupplierName(): string {
    const loggedInUser = this.routerConstants.getLoggedInUser();
    const isSupplierUser = this.userType === 'scw_supplier_user'
      || loggedInUser?.role?.value === 'scw_supplier_user';
    if (isSupplierUser) {
      return loggedInUser?.mcoCompany?.split('-RFQ')[0]
        || loggedInUser?.employeeCompany
        || '';
    }
    return 'Cisco';
  }

  onFeedbackImageSelected(files: FileList): void {
    if (!files || files.length === 0) {
      return;
    }

    const newFiles = Array.from(files);
    const merged = [...this.feedbackImageFiles, ...newFiles];

    const result = this.fileUploadService.validateImageFiles(
      merged, this.maxFeedbackImages, this.maxFeedbackImagesTotalBytes, this.feedbackImageExtensions
    );

    if (!result.valid) {
      this.feedbackImageValidationError = result.errorMessage;
      return;
    }

    this.feedbackImageFiles = merged;
    this.feedbackImageValidationError = '';
  }

  onFeedbackImageDropped(event: FileList): void {
    this.onFeedbackImageSelected(event);
  }

  removeFeedbackImage(index: number): void {
    this.feedbackImageFiles.splice(index, 1);
    if (this.feedbackImageFiles.length > 0) {
      const result = this.fileUploadService.validateImageFiles(
        this.feedbackImageFiles, this.maxFeedbackImages,
        this.maxFeedbackImagesTotalBytes, this.feedbackImageExtensions
      );
      this.feedbackImageValidationError = result.valid ? '' : result.errorMessage;
    } else {
      this.feedbackImageValidationError = '';
    }
  }

  downloadFeedbackImage(feedbackId: string, imageId: number, fileName: string): void {
    this.loaderService.openLoader();
    this.splunkLogService.downloadFeedbackImage(feedbackId, imageId).subscribe({
      next: (blob: Blob) => {
        this.loaderService.closeLoader();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
      },
      error: (err: any) => {
        this.loaderService.closeLoader();
        this.openConfirmationPopup('Error', err?.error?.errorMsg || 'Failed to download image', false);
      }
    });
  }

  onClickSubmitFeedback() {
    if (this.feedbackForm.invalid) {
      return;
    }
    const requestObj = {
      moduleType: this.getSelectedModuleTypeIds(),
      comment: this.feedbackForm.get('feedbackComment').value,
      supplierName: this.getFeedbackSupplierName()
    };

    this.loaderService.openLoader();

    if (this.feedbackImageFiles.length > 0) {
      const formData = new FormData();
      formData.append('data', new Blob([JSON.stringify(requestObj)], { type: 'application/json' }));
      for (const file of this.feedbackImageFiles) {
        formData.append('images', file, file.name);
      }
      this.feedbackImageUploading = true;
      this.splunkLogService.submitFeedbackWithImages(formData).subscribe({
        next: (respData: any) => {
          this.feedbackImageUploading = false;
          this.loaderService.closeLoader();
          if (respData?.status === 'E') {
            this.openConfirmationPopup('Error', respData?.errorMsg || 'Error while saving feedback details in database...', false);
            return;
          }
          this.openConfirmationPopup('Confirmation', 'Thank you! Your feedback has been submitted.', false);
          this.onClose('close');
        },
        error: (err: any) => {
          this.feedbackImageUploading = false;
          this.loaderService.closeLoader();
          this.openConfirmationPopup('Error', err?.error?.errorMsg || 'An error occurred', false);
        }
      });
    } else {
      this.splunkLogService.submitFeedback(requestObj).subscribe({
        next: (respData: any) => {
          this.loaderService.closeLoader();
          if (respData?.status === 'E') {
            this.openConfirmationPopup('Error', respData?.errorMsg || 'Error while saving feedback details in database...', false);
            return;
          }
          this.openConfirmationPopup('Confirmation', 'Thank you! Your feedback has been submitted.', false);
          this.onClose('close');
        },
        error: (err: any) => {
          this.loaderService.closeLoader();
          this.openConfirmationPopup('Error', err?.error?.errorMsg || 'An error occurred', false);
        }
      });
    }
  }

  getMyIssues() {
    if (this.myIssuesList.rowData.length === 0) {
      this.loaderService.openLoader();
      this.splunkLogService.viewAllIssues()
        .subscribe({
          next: (respData: any) => {
            this.loaderService.closeLoader();
            this.myIssuesList.rowData = respData.myIssue;
          },
          error: (err: any) => {
            this.loaderService.closeLoader();
            this.openConfirmationPopup('Error', err?.error?.errorMsg || 'An error occurred', false);
          }
        });
    }
  }

  getAllIssues() {
    if (this.allIssueList.rowData.length === 0) {
      this.loaderService.openLoader();
      this.splunkLogService.viewAllIssues()
        .subscribe({
          next: (respData: any) => {
            this.loaderService.closeLoader();
            this.allIssueList.rowData = respData.allIssue;
            this.hideSupplierName();
          },
          error: (err: any) => {
            this.loaderService.closeLoader();
            this.openConfirmationPopup('Error', err?.error?.errorMsg || 'An error occurred', false);
          }
        });
    }
  }

  getFeedbackHistory() {
    this.loaderService.openLoader();
    this.splunkLogService.getFeedbackHistory().subscribe({
      next: (rows: any) => {
        this.loaderService.closeLoader();
        this.feedbackHistoryList.rowData = rows || [];
      },
      error: (err: any) => {
        this.loaderService.closeLoader();
        this.openConfirmationPopup('Error', err?.error?.errorMsg || 'An error occurred', false);
      }
    });
  }

  openFeedbackDetail(row: any) {
    if (!row) {
      return;
    }
    this.selectedFeedbackDetail = row;
    this.showFeedbackDetail = true;
    if (row.isRead === 'N' && row.id != null) {
      this.splunkLogService.markFeedbackRead(row.id).subscribe({
        next: () => {
          row.isRead = 'Y';
          this.feedbackHistoryGrid?.api?.refreshCells({ force: true });
          this.feedbackNotificationService.refreshNow();
        },
        error: () => { /* non-blocking; next poll tick re-syncs badge */ }
      });
    }
  }

  closeFeedbackDetail() {
    this.showFeedbackDetail = false;
    this.selectedFeedbackDetail = null;
  }

  hideSupplierName() {
    if (this.userType === 'scw_supplier_user') {
      this.allIssueGrid.api.setColumnsVisible(['supplier_name'], false);
    }
    else {
      this.allIssueGrid.api.setColumnsVisible(['supplier_name'], true);
    }
    this.allIssueGrid.api.getColumns().forEach((col: any) => {
      col.colDef.suppressColumnsToolPanel = col.visible ? false : true;
    });
    this.allIssueGrid.api.refreshCells({ force: true });
  }

  async getAllIncidentIds() {
    this.incidentIdArr = [];
    this.loaderService.openLoader();
    const respData: any = await lastValueFrom(this.cepmService.getAllIncidents())
      .catch((err: any) => {
        this.loaderService.closeLoader();
        this.openConfirmationPopup('Error', err?.error?.errorMsg || 'An error occurred', false);
      });
    this.loaderService.closeLoader();
    if (respData && Object.keys(respData).length > 0 && respData.incidentNumber.length > 0) {
      this.incidentIdArr = respData.incidentNumber;
    }
    else {
      this.incidentIdArr.push('No active incidents available');
    }
  }

  uploadFile(files: any) {
    this.fileUploadService.checkFileExtension(files, this.supportedFileExtensions);
    if (this.fileUploadService.isInvalidFileFormat) {
      return;
    }
    else {
      this.selectedFiles = files;
      this.issueForm.get('fileName').setValue(files[0].name);
    }
  }

  onFileDropped(event: any) {
    this.uploadFile(event);
  }

  onClickDeleteFile() {
    this.selectedFiles = [];
    this.fileUploadService.isInvalidFileFormat = false;
    this.issueForm.get('fileName').reset();
  }

  onSelectCategory(event: any) {
    this.showDataMeasureName = false;
    this.issueForm.get('dataMeasureName').clearValidators();
    this.issueForm.get('dataMeasureName').reset();
    this.showBrokenLink = false;
    this.issueForm.get('brokenLinkName').clearValidators();
    this.issueForm.get('brokenLinkName').reset();
    if (event.value === 'Report Wrong / Missing Data') {
      this.issueForm.get('dataMeasureName').setValidators([Validators.required]);
      this.showDataMeasureName = true;
    }
    if (event.value === 'Report Broken Link / Application / Access Issues') {
      this.issueForm.get('brokenLinkName').setValidators([Validators.required, Validators.maxLength(149)]);
      this.showBrokenLink = true;
    }
    this.issueForm.get('dataMeasureName').updateValueAndValidity();
    this.issueForm.get('brokenLinkName').updateValueAndValidity();
  }

  onClickSubmit() {
    if (this.issueForm.invalid) {
      return;
    }
    else {
      const shortDesc = this.issueForm.get('category').value === 'Report Wrong / Missing Data' ?
        `Report Wrong / Missing Data - ${this.issueForm.get('dataMeasureName').value}`
        : `Broken Link Name - ${this.issueForm.get('brokenLinkName').value}`;

      const requestObj = {
        caller_id: this.loggedInUser.role.value === 'scw_supplier_user' ? 'scw-external.gen' : this.loggedInUser.userId,
        description: `Issue Description - ${this.issueForm.get('additionalComments').value}`,
        short_description: shortDesc,
        u_business_service: 'Supplier Sourcing',
        contact_type: 'web',
        u_impacted_function: this.loggedInUser.environment === 'prod' ? 'sc-src-scw' : 'sc-scrm bo'
      };

      const supplierName = this.loggedInUser.role.value === 'scw_supplier_user'
        ? (this.loggedInUser.mcoCompany?.split('-RFQ')[0] || this.loggedInUser.employeeCompany || '')
        : '';
      this.loaderService.openLoader();
      this.cepmService.openCase(requestObj, supplierName)
        .subscribe({
          next: (respData: any) => { (async () => {
            this.loaderService.closeLoader();
            if (respData && Object.keys(respData).length > 0) {
              if (respData.number) {
                const cmfmMsg = `Incident ${respData.number} has been opened for "${this.loggedInUser.fullName}","${this.loggedInUser.email}".`;
                if (this.selectedFiles.length > 0) {
                  await this.uploadFileToCase(cmfmMsg, respData.systemId);
                }
                else {
                  if (respData.status === 'S') {
                    this.openConfirmationPopup('Confirmation', `${cmfmMsg}`, false);
                    this.onClose('close');
                  }
                  else if (respData.status === 'E' && respData.errorMsg) {
                    this.openConfirmationPopup('Error', `${cmfmMsg} ${respData.errorMsg}`, false);
                  }
                  else {
                    this.openConfirmationPopup('Error', `${cmfmMsg}. Error while saving incident details in database...`, false);
                  }
                }
              }
              else {
                this.openConfirmationPopup('Error', 'Error while creating case.', false);
              }
            }
          })(); },
          error: (err: any) => {
            this.loaderService.closeLoader();
            this.openConfirmationPopup('Error', err?.error?.errorMsg || 'An error occurred', false);
          }
        });
    }
  }

  async uploadFileToCase(cmfmMsg: any, systemId: any) {
    const formData = new FormData();
    formData.append('file', this.selectedFiles[0]);
    this.loaderService.openLoader();
    await lastValueFrom(this.cepmService.uploadFileToCase(formData, systemId, this.selectedFiles[0].name.replace(/\s/g, '')))
      .then((respData: any) => {
        this.loaderService.closeLoader();
        if (respData && Object.keys(respData).length > 0 && respData.status === 'S') {
          this.openConfirmationPopup('Confirmation', cmfmMsg, false);
          this.onClose('close');
        }
        else if (respData && Object.keys(respData).length > 0 && respData.status === 'E' && respData.errorMsg) {
          this.openConfirmationPopup('Error', `${cmfmMsg} ${respData.errorMsg}`, false);
        }
        else {
          this.openConfirmationPopup('Error', `${cmfmMsg}, Error while uploading file... `, false);
        }
      })
      .catch((err: any) => {
        this.loaderService.closeLoader();
        this.openConfirmationPopup('Error', err?.error?.errorMsg || 'An error occurred', false);
      });
  }

  onSelectIncidentId(event: any) {
    this.incidentId = event.case_no;
    this.incidentComments = [];
    this.loaderService.openLoader();
    this.cepmService.getCaseComments(event.case_no)
      .subscribe({
        next: (respData: any) => {
          this.loaderService.closeLoader();
          if (respData && respData.comments) {
            this.showIncident = true;
            const comments = respData.comments.replace(/"/g, '').split('\n\n');
            comments.forEach((comm: any) => {
              if (comm) {
                const commType = comm.includes('(Additional comments)') ? 'additional comment' : 'work notes';
                const timeNcommentBy = comm.includes('(Work notes (Agent visible))') ? comm.split('(Work notes (Agent visible))')[0]
                  : comm.split('(Additional comments)')[0];
                this.incidentComments.push({
                  comment: comm.includes('(Work notes (Agent visible))') ? comm.split('(Work notes (Agent visible))')[1].replace(/\r/g, '')
                    : comm.split('(Additional comments)')[1].replace(/\r/g, ''),
                  commentType: commType,
                  commentedBy: timeNcommentBy.split(' - ')[1],
                  commentTime: timeNcommentBy.split(' - ')[0]
                });
              }
            });
          }
          else {
            this.openConfirmationPopup('Confirmation', 'Comments Not Available For This Incident', false);
          }
        },
        error: (err: any) => {
          this.loaderService.closeLoader();
          this.openConfirmationPopup('Error', err?.error?.errorMsg || 'An error occurred', false);
        }
      });
  }

  onClose(val: any) {
    this.feedbackImageFiles = [];
    this.feedbackImageValidationError = '';
    this.feedbackImageUploading = false;
    this.clickReportIssues.emit(val);
  }

  onCloseIncident() {
    this.showIncident = false;
  }

  openConfirmationPopup(title: any, msg: any, flag: any) {
    this.modalRefBox = this.modalService.open(ConfirmationComponent, {
      centered: true,
      windowClass: 'alertModalWindowClass',
      backdrop: 'static',
      keyboard: false,
    });
    this.modalRefBox.componentInstance.title = title;
    this.modalRefBox.componentInstance.message = msg;
    this.modalRefBox.componentInstance.showCancelButton = flag;
  }
}
